import {Component, Input} from '@angular/core';
import {ErrorCodes} from "../../../../../../common/enums/states/error-codes";
import {AnalyticsPercentUlComponent} from "../analytics-percent-ul/analytics-percent-ul.component";


@Component({
  selector: 'analytics-percent-ul-card',
  templateUrl: './analytics-percent-ui-card.component.html',
  imports: [
    AnalyticsPercentUlComponent
  ],
  styleUrls: ['./analytics-percent-ui-card.component.css']
})
export class AnalyticsPercentUiCardComponent {
  invalidAnalysisErrorCode?: ErrorCodes = undefined
  @Input() hoverModel: { id: string, selfIdentifier: string } = {id: "", selfIdentifier: ""};
  protected readonly ErrorAnalysis = ErrorCodes;

  constructor() {
  }

  displayNoDataAvailableMessage(status: ErrorCodes | undefined) {
    this.invalidAnalysisErrorCode = status;
  }

}
